import { ILoginProvider, User, UserScope } from '../authTypes';

export type OauthUser = User & { token: string };

export async function fetchAuthStatus(
  OAuth: Pick<ILoginProvider, 'fetchUser' | 'getAccessToken'>,
): Promise<OauthUser | undefined> {
  const user = await OAuth.fetchUser({ _with: [UserScope.PROPERTIES] });

  if (!user) {
    return undefined;
  }

  if (!user.id) {
    throw new Error('Empty user');
  }

  const accessToken = await OAuth.getAccessToken();
  const token = accessToken?.token?.value;

  if (!token) {
    return undefined;
  }

  return { ...user, token };
}
